import React, { useEffect, useState } from "react";
import {
  Form,
  AutoComplete,
  message,
  Divider,
  TimePicker,
  Row,
  Col,
} from "antd";
import moment from "moment";
import EditLocation from "../../assets/images/edit_location.svg";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext.js";
import { AddSettingsLocation, GetTeams } from "../../api's/settings.js";
import CustomInput from "../../components/CustomInput.jsx";
import CustomTitle from "../../components/CustomTitle";
import CustomModal from "../../components/CustomModal.jsx";
import MapComponent from "../../components/MapComponent.jsx";
import AddItemButton from "../../components/AddItemButton.jsx";
import { GoogleMapsProvider } from "../../components/GoogleMapsProvider.jsx";
import CustomButton from "../../components/CustomButton.jsx";
import TeamsSelector from "../../components/TeamsSelector.jsx";
import CustomSelect from "../../components/CustomSelect.jsx";
import ContactList from "./ContactList.jsx";
import { DownOutlined } from "@ant-design/icons";
import AddNewContactModal from "../Modals/AddNewContactModal.jsx";
import CustomDeleteModal from "../Modals/CustomDeleteModal.jsx";
import TeamsSelectorCheckbox from "../../components/TeamsSelectorCheckbox.jsx";
import { getTeamsDDLOFFeature } from "../../common/utils/dropDown.js";
import { useSelector } from "react-redux";
const locationTypeList = [
  { value: "WAREHOUSE", label: "Warehouse" },
  { value: "RETAIL", label: "Retail" },
  { value: "HOSPITAL", label: "Hospital" },
  { value: "LAB", label: "Lab" },
  { value: "RESIDENTIAL", label: "Residential" },
  { value: "OTHER", label: "Other" },
];

const LocationForm = ({
  locationData,
  drawerOpen,
  onClose,
  unauthorize,
  refreshLocations,
}) => {
  const [form] = Form.useForm();
  const [contactForm] = Form.useForm();
  const { token } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLatLng, setSelectedLatLng] = useState({
    lat: null,
    lng: null,
  });
  const [options, setOptions] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const isEditing = !!locationData;
  const [openModal, setOpenModal] = useState(false);
  const [modalName, setModalName] = useState("");
  const [contactList, setContactList] = useState(locationData?.contacts || []);
  const [isFormValid, setIsFormValid] = useState(false);
  const [polygon, setPolygon] = useState();
  const [editingContact, setEditingContact] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);
  const [addressInput, setAddressInput] = useState();
  
  const teamsList = useSelector((state) => state.teams.list);
  
    const hasValidTeams = !(
      teamsList.length === 0 ||
      (teamsList.length === 1 && teamsList[0].name.toLowerCase() === "default")
    );

  const [teamsOptions, setTeamsOptions] = useState([]);

  // useEffect(() => {
  //   showSpin();
  //   GetTeams(token)
  //     .then((res) => {
  //       if (res?.data?.data?.is_success) {
  //         const fetchedTeams = res.data.data?.data || [];
  //         const formattedTeams = fetchedTeams.map((team) => ({
  //           id: team.id,
  //           name: team.name,
  //           color: team.color || "#D3D3D3",
  //         }));

  //         setTeamsOptions(formattedTeams);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching teams:", error);
  //       message.error("Error fetching teams");
  //     })
  //     .finally(() => hideSpin());
  // }, []);


   useEffect(() => {
      getTeamsDDLOFFeature(token,"Locations").then((val) => {
        if (val && val.length > 0) {
          setTeamsOptions(val);
        }
      });
    }, []);
  
  
  
  const handleSetModalOpen = (isOpen) => {
    if (!isOpen) {
      setPolygon(null);
      setModalOpen(false);
    }
  };

  const onModalConfirm = () => {
    if (polygon && polygon.length > 0) {
      message.success("Polygon created");
      setModalOpen(false);
    } else {
      message.error("Please mark proper area");
    }
  };
  const getPolygon = (val) => {
    console.log("get polygon val : ", val);
    if (val && val.length > 0) {
      setPolygon(val);
    }
  };
  
  const submitNewContact = (contact) => {
    const isEditing = !!editingContact;
  
    if (contact.is_primary_contact) {
      const alreadyPrimary = contactList.some((c) =>
        c.is_primary_contact && (!isEditing || c.id !== editingContact.id)
      );
  
      if (alreadyPrimary) {
        message.error("Only one primary contact can be selected.");
        return;
      }
    }
  
    if (isEditing) {
      setContactList((prevContacts) =>
        prevContacts.map((c) =>
          c.id === editingContact.id ? { ...c, ...contact } : c
        )
      );
    } else {
      const newContact = { ...contact, id: Date.now() };
      setContactList((prevContacts) => [...prevContacts, newContact]);
    }
  
    contactForm.resetFields();
    setOpenModal(false);
    setEditingContact(null);
  };
  
  console.log('contact list' , contactList);

  const handleEditContact = (contact) => {
    setEditingContact(contact);
    contactForm.setFieldsValue({
      name: contact.name,
      title: contact.title,
      email: contact.email,
      phone_number: contact.phone_number,
      is_primary_contact: contact.is_primary_contact,
      preferred_language: contact?.preferred_language
    });
    setOpenModal(true);
  };

  const handleDeleteClick = (contact) => {
    setContactToDelete(contact);
    setDeleteModalVisible(true);
  };

  const handleConfirmDelete = () => {
    if (!contactToDelete) return;

    console.log("Removing contact from state:", contactToDelete.id);
    setContactList((prevContacts) =>
      prevContacts.filter((contact) => contact.id !== contactToDelete.id)
    );
    setDeleteModalVisible(false);
    setContactToDelete(null);
  };

  useEffect(() => {
    if (locationData) {
      form.setFieldsValue({
        name: locationData.name || "",
        address: locationData.address || "",
        facility_type: locationData.facility_type || "",
        start: locationData.receiving_hours?.start
          ? moment(locationData.receiving_hours.start)
          : null,
        end: locationData.receiving_hours?.end
          ? moment(locationData.receiving_hours.end)
          : null,
        teams: locationData.teams,
      });
      setAddressInput(locationData?.address);
      setSelectedTeams(locationData.teams || []);
      setSelectedLatLng({
        lat: locationData.latitude,
        lng: locationData.longitude,
      });
      setPolygon(locationData.polygon || []);
      setContactList(locationData.contacts || []);
    } else {
      setAddressInput("");
      form.resetFields();
      setSelectedTeams([]);
      setSelectedLatLng({ lat: null, lng: null });
      setPolygon([]);
      setContactList([]);
    }
  }, [locationData, form, drawerOpen]);

  const handleAddressChange = (value) => {
    if (!value) {
      setSelectedLatLng({ lat: "", lng: "" });
    }
  };

  const handleAddressPlaceSelect = (place) => {
    if (!place?.geometry?.location) {
      console.error("Invalid place object:", place);
      return;
    }
    setSelectedLatLng({
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    });
  };

  const openMapModal = () => {
    setModalOpen(true);
    setModalName("Draw Polygon");
    //setPolygon(null);
  };

  const onFinish = (values) => {
    let primaryContactsCount = contactList.filter(
      (item) => item.is_primary_contact === true
    );

    if (primaryContactsCount.length > 1) {
      message.error("Only one primary contact can be selected.");
      return;
    }

    // if (primaryContactsCount.length < 1) {
    //   message.error("Please select at least one primary contact.");
    //   return;
    // }
    let receiving_hours = {
      start: values?.start ? values.start.valueOf() : null,
      end: values?.end ? values.end.valueOf() : null,
    };

    let selectedTeamIds = selectedTeams.map((team) => team.id);

    let model = {
      name: values.name,
      address: values.address,
      facility_type: values.facility_type,
      latitude: selectedLatLng.lat,
      longitude: selectedLatLng.lng,
      polygon: polygon?.length > 0 ? polygon : [],
      contacts: contactList,
      receiving_hours,
      start: receiving_hours.start,
      end: receiving_hours.end,
      id: locationData?.id || null,
      teams: selectedTeamIds,
    };

    submitLocation(model);
  };

  const submitLocation = (model) => {
    showSpin();
    setIsFormValid(true);
    let formattedReceivingHours = {
      start: model.start ? moment(model.start).toISOString() : null,
      end: model.end ? moment(model.end).toISOString() : null,
    };
    let formattedContacts = contactList.map((contact, index) => ({
      key: String(index + 1),
      name: contact.name,
      title: contact.title,
      email: contact.email,
      phone_number: contact.phone_number || "",
      country_code: contact.country_code || "",
      preferred_language: contact.preferred_language || "English(US)",
      is_primary_contact: contact.is_primary_contact || false,
    }));

    let teamIds = selectedTeams.map((team) => team.id);

    let requestPayload = {
      name: model.name,
      address: model.address,
      facility_type: model.facility_type,
      latitude: model.latitude,
      longitude: model.longitude,
      polygon: model.polygon || [],
      receiving_hours: formattedReceivingHours,
      contacts: formattedContacts,
      teams: teamIds,
      id: locationData?.id || null,
    };
 
    AddSettingsLocation(token, requestPayload)
      .then((res) => {
        const data = res?.data || null;
        if (data && data?.data?.is_success) {
          message.success("Location saved successfully.");
          form.resetFields();
          setSelectedLatLng({ lat: null, lng: null });
          setPolygon([]);
          onClose();
          if (refreshLocations) {
            refreshLocations();
          }
        } else {
          message.error(data?.data?.message);
        }
      })
      .catch((error) => {
        unauthorize(error);
        message.error("Failed to save location. Please try again.");
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div
          style={{
            position: "absolute",
            top: "40px",
            paddingTop: "0px",
            left: "0",
            paddingLeft: "32px",
            width: "100%",
            background: "#fff",
            zIndex: "2",
          }}
        >
          <CustomTitle
            text={isEditing ? "Edit location" : "Add location"}
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
        </div>
        {/* <div
          style={{
            position: "sticky",
            top: "0",
            left: "0",
            width: "100%",
            background: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            {isEditing ? "Edit Location" : "Add Location"}
          </h2>
        </div> */}
        <div
          style={{
            flex: 1,
            // overflowY: "auto",
            paddingBottom: "140px",
            paddingTop: "16px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="custom-scrollbar"
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                label="Name"
                className="custom-input form-input-style"
                name="name"
                rules={[
                  { required: true, message: "Please enter location name" },
                  {
                    pattern:
                      /^(?=.*[A-Za-zÀ-ÖØ-öø-ÿ])[A-Za-zÀ-ÖØ-öø-ÿ0-9\s.'\-()]{2,100}$/,
                    message:
                      "Name must include at least one letter and only valid characters",
                  },
                  {
                    type: "string",
                    min: 3,
                    message: "Must be at least 3 characters",
                  },
                ]}
              >
                <CustomInput
                  placeholder="Enter location name"
                  bgColor="#F3F3F3"
                  height="36px"
                  textColor="#000000"
                  borderRadius="8px"
                  border="none"
                  placeholderColor="#5E5E5E"
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <GoogleMapsProvider>
                <div style={{ position: "relative" }}>
                  <Form.Item
                    label={"Address"}
                    className="custom-input form-input-style"
                    name={"address"}
                    rules={[
                      { required: true, message: "Please enter address" },
                    ]}
                    style={{
                      width: "100%",
                      marginBottom: "0",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <AutoComplete
                        style={{
                          width: "88%",
                          boxShadow: "none",
                          height: "36px",
                          backgroundColor: "#F3F3F3",
                          color: "#5E5E5E",
                          borderRadius: "8px",
                          border: "none",
                          marginBottom: "0px",
                        }}
                        placeholder="Enter address"
                        className="custom-autocomplete"
                        options={options}
                        value={addressInput}
                        onSelect={(value, option) => {
                          const placeId = option.placeId; // <-- Extract from custom field
                          if (!placeId) {
                            console.error("Invalid place ID");
                            return;
                          }

                          const service =
                            new window.google.maps.places.PlacesService(
                              document.createElement("div")
                            );

                          service.getDetails({ placeId }, (place, status) => {
                            if (
                              status ===
                              window.google.maps.places.PlacesServiceStatus.OK
                            ) {
                              const formatted = place.formatted_address;

                              form.setFieldsValue({ address: formatted });
                              setAddressInput(formatted);

                              setSelectedLatLng({
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng(),
                              });

                              console.log("Selected Address:", formatted);
                            } else {
                              console.error(
                                "Failed to fetch place details:",
                                status
                              );
                            }
                          });
                        }}
                        onSearch={(text) => {
                          if (!text) {
                            setOptions([]);
                            return;
                          }

                          const service =
                            new window.google.maps.places.AutocompleteService();

                          service.getPlacePredictions(
                            { input: text },
                            (predictions, status) => {
                              if (
                                status ===
                                window.google.maps.places.PlacesServiceStatus.OK
                              ) {
                                setOptions(
                                  predictions.map((prediction) => ({
                                    label: prediction.description,
                                    value: prediction.description, // ✅ What appears in input
                                    placeId: prediction.place_id, // ✅ What we use internally
                                  }))
                                );
                              } else {
                                setOptions([]);
                                console.error(
                                  "Failed to fetch predictions:",
                                  status
                                );
                              }
                            }
                          );
                        }}
                        onChange={(value) => {
                          setAddressInput(value);
                          form.setFieldsValue({ address: value });
                        }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "0",
                          bottom: "50%",
                          transform: "translateY(50%)",
                        }}
                      >
                        <CustomButton
                          isFormValid={
                            !(selectedLatLng.lat && selectedLatLng.lng)
                          }
                          image={EditLocation}
                          iconPosition={"left"}
                          imageWidth={"12px"}
                          border="none"
                          width="28px"
                          height="28px"
                          borderRadius="50%"
                          bgColor="#f5f5f5"
                          color="#000"
                          boxShadow="none"
                          onClick={() => openMapModal()}
                          padding={"0"}
                          fontSize={"12px"}
                        />
                      </span>
                    </div>
                  </Form.Item>
                </div>
              </GoogleMapsProvider>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Location type"
                className="custom-input  form-input-style"
                name="facility_type"
                rules={[{ required: true, message: "Select a type" }]}
              >
                <CustomSelect
                  // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                  placeholder="Select..."
                  options={locationTypeList}
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  height="36px"
                  border="none"
                  placeholderColor="#5E5E5E"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Operating hours"
                style={{ marginBottom: "0px", width: "100%" }}
              >
                <Row gutter={[0, 0]}>
                  <Col span={11}>
                    <Form.Item
                      name={"start"}
                      rules={[
                        { required: false, message: "Start time is required" },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        format="h:mm A"
                        placeholder="Select..."
                        suffixIcon={
                          <DownOutlined
                            style={{ color: "#5E5E5E", fontSize: "12px" }}
                          />
                        }
                        className="custom-timepicker"
                        style={{
                          height: "36px",
                          width: "100%",
                          backgroundColor: "#F3F3F3",
                          color: "black",
                          borderRadius: "8px",
                          border: "none",
                          boxShadow: "none",
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <span
                    style={{ color: "black", margin: "9px", fontSize: "14px" }}
                  >
                    to
                  </span>
                  <Col span={11}>
                    <Form.Item
                      name={"end"}
                      rules={[
                        { required: false, message: "End time is required" },
                      ]}
                    >
                      <TimePicker
                        use12Hours
                        suffixIcon={
                          <DownOutlined
                            style={{ color: "#5E5E5E", fontSize: "12px" }}
                          />
                        }
                        format="h:mm A"
                        placeholder="Select..."
                        className="custom-timepicker"
                        style={{
                          height: "36px",
                          width: "100%",
                          backgroundColor: "#F3F3F3",
                          color: "black",
                          borderRadius: "8px",
                          border: "none",
                          boxShadow: "none",
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
            {hasValidTeams && (
              <Col span={24}>
                <Form.Item
                  label="Teams with access"
                  className="custom-input form-input-style"
                  name="teams"
                  rules={[{ required: true, message: "Please select value" }]}
                >
                  <TeamsSelector
                    teamsOptions={teamsOptions}
                    selectedTeams={selectedTeams}
                    onChange={setSelectedTeams}
                    formState={isEditing ? "edit" : "add"}
                  />
                </Form.Item>
              </Col>
            )}

            <Col span={24}>
              <Divider style={{ borderColor: "#D9D9D9", margin: "0px" }} />
            </Col>

            <Col span={24}>
              <CustomTitle
                text="Contacts"
                marginBottom="0px"
                fontSize={18}
                fontWeight="700"
              />
            </Col>
            {contactList?.length > 0 && (
              <Col span={24}>
                <ContactList
                  data={contactList}
                  handleEdit={handleEditContact}
                  handleDeleteClick={handleDeleteClick}
                />
              </Col>
            )}

            <Col span={24}>
              <AddItemButton
                fontSize="12px"
                marginTop="0px"
                fontWeight="600"
                text="Add contact"
                onClick={() => {
                  setEditingContact(null);
                  contactForm.resetFields();
                  setOpenModal(true);
                }}
              />
            </Col>
          </Row>
        </div>

        <div
          style={{
            background: "#fff",
            position: "absolute",
            bottom: "0",
            left: "0",
            width: "100%",
            padding: "0 24px 24px",
          }}
        >
          <Row gutter={[0, 8]} style={{ marginTop: "0" }}>
            <CustomButton
              key="button1"
              text="Save"
              bgColor="#000"
              htmlType="submit"
              color="#fff"
              fontSize="16px"
              fontWeight="600"
              boxShadow="none"
              height="48px"
              width="100%"
              borderRadius={"8px"}
            />

            <CustomButton
              key="button2"
              text="Cancel"
              bgColor="transparent"
              color="#000"
              fontSize="16px"
              padding={"11.5px 0px 12px 0px"}
              fontWeight="600"
              boxShadow="none"
              height="auto"
              width="100%"
              border="none"
              marginTop="0px"
              onClick={onClose}
            />
          </Row>
        </div>
        <CustomDeleteModal
          visible={deleteModalVisible}
          onClose={() => setDeleteModalVisible(false)}
          onConfirm={handleConfirmDelete}
          title="Remove Contact"
          message="Removing this contact will prevent selecting it for future use."
          cancelText="Cancel"
          confirmText="Remove"
          confirmColor="#DE1135"
        />
        
      </Form>
      <GoogleMapsProvider>
      <CustomModal
          modalOpen={modalOpen}
          setModalOpen={handleSetModalOpen}
          modalTitle={`${modalName}`}
          modalText=""
          modalSize={680}
          buttonText1={"Cancel"}
          buttonText2={"Submit"}
          isFormValid={isFormValid}
          onConfirmClick={onModalConfirm}
        >
          <MapComponent
            onPolygonCompleted={getPolygon}
            selectedLatLng={selectedLatLng}
            polygon={polygon}
          />
        </CustomModal>
        </GoogleMapsProvider>
      <AddNewContactModal
        setEditingContact={setEditingContact}
        title={editingContact ? "Edit contact" : "Add contact"}
        form={contactForm}
        modalOpen={openModal}
        setModalOpen={setOpenModal}
        apiCall={submitNewContact}
        isFormValid={isFormValid}
      />
    </>
  );
};

export default LocationForm;
